import { Observable, Observer } from 'rxjs';

export interface IObservableWithPending<T> {
  done: boolean;
  result?: T;
  error?: Error;
  pending: boolean;
}

export const observableWithPending = <T>(
  observable$: Observable<T>,
): Observable<IObservableWithPending<T>> =>
  new Observable((observer: Observer<IObservableWithPending<T>>) => {
    observer.next({ done: false, pending: true });
    observable$.subscribe({
      error(error) {
        observer.next({ done: true, pending: false, error });
        observer.complete();
      },
      next(result) {
        observer.next({ done: true, pending: false, result });
        observer.complete();
      },
    });
  });
